module.exports = __webpack_public_path__ + "img/login-sub-group.e6052dc2.svg";